$(() => {
    if (document.getElementById('client-tutorial') != null) {
        // ツアー内容
        const steps = [
            {
                title: "PROBASEへようこそ！",
                content: "PROBASEはフリーランスとの取り引きを円滑にし、効率化するサービスです。<br>まずは基本的な利用方法を説明します。",
                order: 1,
            },
            {
                title: "契約詳細の確認",
                content: "PROBASEに登録されている契約の詳細が確認できます。",
                target: "#tutorial_contract",
                order: 2
            },
            {
                title: "業務報告書・請求書の確認",
                content: "業務報告書・請求書が提出されるとこちらから内容を確認できます。<br>提出をお待ちください。",
                target: "#tutorial_report",
                order: 3
            },
            {
                title: "個人設定の確認/編集",
                content: "メールアドレス・パスワードなどの個人の設定はこちらから確認/編集が可能です。",
                target: "#tutorial_setting",
                order: 4
            }
        ];
        startTutorial(steps);
    }

    if (document.getElementById('demo-client-tutorial') != null) {
        // ツアー内容
        const steps = [
            {
                title: "PROBASEへようこそ！",
                content: "PROBASEはフリーランスとの取り引きを円滑にし、効率化するサービスです。<br>まずは基本的な利用方法を説明します。",
                order: 1,
            },
            {
                title: "新規契約情報登録",
                content: "パートナーと締結した契約のPROBASEへの登録はこちらから行います。<br>※デモ版では新規契約を登録することはできません",
                target: "#tutorial_create_contract",
                order: 2
            },
            {
                title: "契約詳細の確認",
                content: "PROBASEに登録した契約の詳細が確認できます。",
                target: "#tutorial_contract",
                order: 3
            },
            {
                title: "業務報告書・請求書の確認",
                content: "パートナーの業務報告書・請求書が提出されるとこちらから内容を確認できます。",
                target: "#tutorial_report",
                order: 4
            },
            {
                title: "個人設定の確認/編集",
                content: "メールアドレス・パスワードなどの個人の設定はこちらから確認/編集が可能です。<br>※デモ版では設定を変更することはできません",
                target: "#tutorial_setting",
                order: 5
            }
        ];
        startTutorial(steps);

    }

    function startTutorial(steps)
    {
        // ダイアログの設定
        const options = {
            steps: steps,
            nextLabel: "次へ",
            prevLabel: "戻る",
            finishLabel: "終了",
            dialogZ: 1200,
            closeButton: false,
            exitOnEscape: false,
            exitOnClickOutside: false        
        };
        const tg = new tourguide.TourGuideClient(options);

        // ツアースタート
        tg.start();
        // 終了ボタン後にTOPへ遷移させる
        tg.onFinish(() => {
            window.location.href = "/client/top";
        });
        // aタグは無効
        $("a").on("click", function() {
            event.preventDefault();
        });
    }
});
